/*
 * @Author: jiaoxiaojie jiaoxiaojie666@sina.com
 * @Date: 2022-05-17 21:58:18
 * @LastEditors: jiaoxiaojie jiaoxiaojie666@sina.com
 * @LastEditTime: 2023-11-27 11:22:40
 * @FilePath: \web-qiankun\main\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import store from './store'
// import { registerMicroApps, start, setDefaultMountApp } from 'qiankun'
import { registerMicroApps, start } from 'qiankun'

// import microApps from './micro-app'
// import http from './utils/http'
import 'nprogress/nprogress.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import '../src/assets/icon/iconfont.css'
import '../src/assets/menu_icon/iconfont.css' // 这里是css新添加的 右侧的各个系统的一级子菜单图标的 样式
import waterfall from 'vue-waterfall2'

import { AuthNavigationbar } from '@/api/main/main'
import 'web-public-jy/css/index.css'
import webPublicJy from 'web-public-jy'
import router from './router'
import '../src/utils/watermarkerp'
import VueCookies from 'vue-cookies'
var microApps = []
var apps = []
gtsidbarlist()

Vue.use(waterfall)
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.use(webPublicJy)
Vue.use(VueCookies)

function gtsidbarlist () {
  AuthNavigationbar({}).then(res => {
    if (res.status === 200) {
      Vue.prototype.$authListDate = res.data
      var authListDateArr = JSON.parse(JSON.stringify(res.data))
      // 定义白名单
      var waitRouterarr = [
        {
          activeRule: '/synthesize',
          icon: 'iconfont myicon-gonggongziyuanjiaoyi',
          sysCode: 'synthesize',
          sysName: '公共资源',
          url: '/subapp/synthesize/index.html'
        },
        {
          activeRule: '/thr',
          icon: 'iconfont myicon-gonggongziyuanjiaoyi',
          sysCode: 'thr',
          sysName: '投标作业',
          url: '/subapp/thr/index.html'
        }
      ]
      for (var i = 0; i < waitRouterarr.length; i++) {
        var iscluderouter = authListDateArr.find((item) => item.activeRule === waitRouterarr[i].activeRule)
        if (!iscluderouter) {
          authListDateArr.push(waitRouterarr[i])
        }
      }
      microApps = res.data.map(item => {
        item.entry = item.url
        // item.entry = 'http://localhost:9528/subapp/audit/'
        item.name = item.sysCode
        return {
          ...item,
          container: '#subapp-viewport', // 子应用挂载的div
          props: {
            routerBase: item.activeRule, // 下发基础路由
            getGlobalState: store.getGlobalState // 下发getGlobalState方法
          }
        }
      })
    }
  }).then(res => {
    // 定义loader方法，loading改变时，将变量赋值给App.vue的data中的isLoading
    function loader (loading) {
      if (instance && instance.$children) {
        // instance.$children[0].isLoading = loading
      }
    }
    const instance = new Vue({
      router,
      render: h => h(App)
    }).$mount('#app')
    // 给子应用配置加上loader方法
    apps = microApps.map(item => {
      return {
        ...item,
        loader
      }
    })
  }).then(res => {
    registerMicroApps(apps, {
      beforeLoad: app => {
        console.log('before load app.name====>>>>>', app.name)
      },
      beforeMount: [
        app => {
          console.log('[LifeCycle] before mount %c%s', 'color: green;', app.name)
        }
      ],
      afterMount: [
        app => {
          console.log('[LifeCycle] after mount %c%s', 'color: green;', app.name)
        }
      ],
      afterUnmount: [
        app => {
          console.log('[LifeCycle] after unmount %c%s', 'color: green;', app.name)
        }
      ]
    })
  })
}
// 取消预加载
start({ prefetch: false, strictStyleIsolation: false })
// start({ prefetch: function () {}, strictStyleIsolation: false })
// setDefaultMountApp('/sso-vue')
// 默认启动项，官网的api，暂时没有使用
// start({ prefetch: function () {}, strictStyleIsolation: false })
